import type { IState } from 'redux/state';
import { ticApi } from '../api-slice/tic.apiSlice';

/**
 * Base for reading API/RTK Query slices
 *
 * @example
 * export const getSomeApiRTKQueryBase = createSelector([getTicApiSlice], apiState => {
 *   return ticApi.endpoints.someOperationId.select(undefined)({
 *     [ticApi.reducerPath]: apiState,
 *   });
 * });
 */

export const getTicApiSlice = (state: IState) => state[ticApi.reducerPath];
